export default __webpack_public_path__ + "static/media/PPII.7b5b0e38.png";